import './styles.css.js';
import { Button } from '@magnetic/button';
import { useClassNames } from '@magnetic/hooks';
import { IcCaretRight } from '@magnetic/icons';
import { Text } from '@magnetic/text';
import React, { forwardRef, useContext, useCallback } from 'react';
import { useNavContext } from '../nav-context.js';
import { NavDrawerContentContext } from './content.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useWrappedClick = /* @__PURE__ */ __name(({
  drawerContentId,
  onClick
}) => {
  const { setOpenDrawerId } = useNavContext();
  return useCallback(
    (event) => {
      onClick == null ? void 0 : onClick(event);
      setOpenDrawerId == null ? void 0 : setOpenDrawerId(drawerContentId);
    },
    [onClick, drawerContentId, setOpenDrawerId]
  );
}, "useWrappedClick");
const RenderNavDrawerNavigation = /* @__PURE__ */ __name(({ children, className, onClick, to, ...props }, ref) => {
  const wrappedClick = useWrappedClick({ drawerContentId: to, onClick });
  const { density } = useContext(NavDrawerContentContext);
  const classNames = useClassNames(
    className,
    "mds-nav-drawer-item",
    `mds-nav-drawer-item-${density}`
  );
  return /* @__PURE__ */ React.createElement(Button, {
    className: classNames,
    kind: "tertiary",
    onClick: wrappedClick,
    ref,
    ...props
  }, /* @__PURE__ */ React.createElement(Text, {
    className: "line-clamp",
    size: "p3"
  }, children), /* @__PURE__ */ React.createElement(IcCaretRight, {
    "aria-hidden": "true",
    className: "mds-nav-drawer-item-caret",
    role: "presentation"
  }));
}, "RenderNavDrawerNavigation");
const NavDrawerNavigation = forwardRef(RenderNavDrawerNavigation);
NavDrawerNavigation.displayName = "Nav.Drawer.Navigation";

export { NavDrawerNavigation };
//# sourceMappingURL=navigation.js.map
